import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private readonly desktopCollapsedStorageKey = 'desktopSidebarCollapsed';
  private _isOpenMenu$ = new BehaviorSubject<boolean>(false);
  private _isDesktopCollapsed$ = new BehaviorSubject<boolean>(this.getStoredDesktopCollapsedState());

  get isOpenMenu$(): Observable<boolean> {
    return this._isOpenMenu$.asObservable();
  }

  setMenuState(state: boolean) {
    this._isOpenMenu$.next(state);
  }

  get isDesktopCollapsed$(): Observable<boolean> {
    return this._isDesktopCollapsed$.asObservable();
  }

  get isDesktopCollapsed(): boolean {
    return this._isDesktopCollapsed$.value;
  }

  toggleDesktopCollapsed() {
    const collapsed = !this._isDesktopCollapsed$.value;
    this._isDesktopCollapsed$.next(collapsed);

    try {
      localStorage.setItem(this.desktopCollapsedStorageKey, String(collapsed));
    } catch {
      // The in-memory preference still works when storage is unavailable.
    }
  }

  private getStoredDesktopCollapsedState(): boolean {
    try {
      return localStorage.getItem(this.desktopCollapsedStorageKey) === 'true';
    } catch {
      return false;
    }
  }

  // Kept here rather than in the switcher itself so the list stays expanded
  // across project switches even if the sidebar gets re-created on the way.
  private _isProjectSwitcherOpen$ = new BehaviorSubject<boolean>(false);

  get isProjectSwitcherOpen$(): Observable<boolean> {
    return this._isProjectSwitcherOpen$.asObservable();
  }

  setProjectSwitcherOpen(state: boolean) {
    this._isProjectSwitcherOpen$.next(state);
  }
}
